// extracted by mini-css-extract-plugin
export default {"container":"ConversationsDetails_container__nG8wX","toolbar":"ConversationsDetails_toolbar__KSaEt"};